/** Gelber Hinweis „Sie senden gerade als …“. Auf der Unterrichtsverwaltung stört er. */

const HIDDEN_ON = ['/', '/login', '/start'];

export function emailSenderBannerVisible({ pathname, bannerHidden, senderConfig }) {
  if (bannerHidden || !senderConfig) return false;
  if (HIDDEN_ON.includes(pathname)) return false;
  if (String(pathname || '').startsWith('/unterrichtsverwaltung')) return false;
  return true;
}
